import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component } from "../../../../../chunks/ssr.js";
import { a as allUnits } from "../../../../../chunks/unit.js";
import "../../../../../chunks/api.js";
import { S as SortableTable } from "../../../../../chunks/SortableTable.js";
import { E as EditButton } from "../../../../../chunks/EditButton.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { L as Label } from "../../../../../chunks/Label.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { S as Search } from "../../../../../chunks/Search.js";
const UnitEditModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_allUnits;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  let { open = false } = $$props;
  let { unit } = $$props;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.unit === void 0 && $$bindings.unit && unit !== void 0) $$bindings.unit(unit);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        if (unit && !unit.address) {
          unit.address = {
            name: unit.name,
            shortKey: unit?.shortKey || "",
            street: "",
            zip: "",
            number: "",
            place: "",
            country: "Deutschland"
          };
        }
      }
    }
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { title: unit?.name, open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${unit ? `<form><h3 class="text-lg text-neutral-600 mb-3" data-svelte-h="svelte-1403v77">Basiseigenschaften</h3> <div class="flex gap-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-15ueaex">Name</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { required: true, value: unit.name },
                {
                  value: ($$value) => {
                    unit.name = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-bk5h5r">Shortcode</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { required: true, value: unit.shortKey },
                {
                  value: ($$value) => {
                    unit.shortKey = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div> <div class="grid gap-3 grid-cols-2 mt-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-k5yu73">Telefon</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { required: true, value: unit.phoneNumber },
                {
                  value: ($$value) => {
                    unit.phoneNumber = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1bg9cgq">Email</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  required: true,
                  type: "email",
                  value: unit.email
                },
                {
                  value: ($$value) => {
                    unit.email = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div> ${unit?.address ? `<div class="flex gap-3 mt-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-5gm4vw">Straße</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { value: unit.address.street },
                {
                  value: ($$value) => {
                    unit.address.street = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 " }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1qc6mp5">Hausnummer</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { value: unit.address.number },
                {
                  value: ($$value) => {
                    unit.address.number = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div> <div class="flex gap-3 mt-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-e4geas">PLZ</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { value: unit.address.zip },
                {
                  value: ($$value) => {
                    unit.address.zip = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1fqticn">Ort</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { value: unit.address.place },
                {
                  value: ($$value) => {
                    unit.address.place = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div> ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 mt-3" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-14yvg2f">Land</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { value: unit.address.country },
                {
                  value: ($$value) => {
                    unit.address.country = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}` : ``} <div class="flex mt-3 justify-end">${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
            default: () => {
              return `Speichern`;
            }
          })}</div></form>` : ``}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $allUnits, $$unsubscribe_allUnits;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => $allUnits = value);
  let open = false;
  let currentUnit = null;
  let search = "";
  const openEditModal = (unit) => {
    currentUnit = unit;
    open = true;
  };
  const header = [
    {
      property: "name",
      label: "Name",
      sortable: true
    },
    {
      property: "address",
      label: "Adresse",
      render: (item) => {
        return item.address ? `${item.address.street} ${item.address.number}, ${item.address.zip} ${item.address.place}` : '<span class="text-red-500">Keine Adresse vergeben</span>';
      }
    },
    {
      property: "email",
      label: "E-Mail",
      render: (item) => {
        return item.email ? item.email : '<span class="text-red-500">Keine E-Mail vergeben</span>';
      }
    },
    {
      property: "id",
      label: "Actions",
      component: EditButton,
      props: {
        onClick: (id) => {
          openEditModal($allUnits.find((x) => x.id === id));
        }
      }
    }
  ];
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-vbihqe_START -->${$$result.title = `<title>Units</title>`, ""}<!-- HEAD_svelte-vbihqe_END -->`, ""} ${validate_component(Search, "Search").$$render(
      $$result,
      { value: search },
      {
        value: ($$value) => {
          search = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        data: $allUnits.filter((x) => x.name.toLowerCase().includes(search.toLowerCase())),
        header
      },
      {},
      {}
    )} ${validate_component(UnitEditModal, "UnitEditModal").$$render(
      $$result,
      { unit: currentUnit, open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {}
    )}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
